import { Box, Typography } from '@mui/material'

interface JourneyDetailsProps {
  status?: string
  timeStatus?: string
}
const containerStyles = {
  backgroundColor: '#fff',
  border: '1px solid #e0e0e0',
  borderRadius: 2,
  p: 2,
  mb: 2,
  mx: 2,
}

const contentWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}

const labelStyles = {
  fontSize: '12px',
  color: '#999',
  fontWeight: 400,
  display: 'block',
  mb: 0.5,
}

const statusRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
}

const statusTextStyles = {
  fontSize: '16px',
  fontWeight: 600,
  color: '#333',
}

const dotIndicatorStyles = {
  width: 6,
  height: 6,
  borderRadius: '50%',
  backgroundColor: '#2E7D32',
}

const timeStatusStyles = {
  fontSize: '13px',
  fontWeight: 600,
  color: '#2E7D32',
}

export const JourneyDetails = ({ status, timeStatus }: JourneyDetailsProps) => {
  return (
    <Box sx={containerStyles}>
      <Box sx={contentWrapperStyles}>
        <Box>
          <Typography variant='caption' sx={labelStyles}>
            Journey details
          </Typography>

          <Box sx={statusRowStyles}>
            <Typography variant='body1' sx={statusTextStyles}>
              {status}
            </Typography>

            <Box sx={dotIndicatorStyles} />

            <Typography variant='body2' sx={timeStatusStyles}>
              {timeStatus}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
